import React, { useState, useContext } from "react";
import axios from "axios";
import {
  Button,
  Typography,
  Paper,
  Box,
  Alert,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import AuthContext from "../../contexts/Islogin";

const Wallet = () => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { url } = useContext(AuthContext);

  const handleSubmit = () => {
    setError(null);
    setResponse(null);
    setLoading(true);

    const token = localStorage.getItem("token");

    axios
      .post(
        `${url}api/v1/trons/wallet`,
        null,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        setResponse(res.data);
      })
      .catch((err) => {
        console.error(err);
        if (err.response) {
          setError(err.response.data);
        } else {
          setError({ message: "Something went wrong" });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Paper elevation={3} sx={{ p: 3, width: '60%', paddingX: '10%', mx: "auto", mt: 5 }}>
      <Typography variant="h6" gutterBottom>
        ایجاد کیف پول TronVault
      </Typography>

      <Box display="flex" flexDirection="column" gap={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "ارسال درخواست"}
        </Button>

        {response && !error && (
          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell>Message</TableCell>
                  <TableCell>{response.message}</TableCell>
                </TableRow>
                {response.wallet && Object.entries(response.wallet).map(([key, value]) => (
                  <TableRow key={key}>
                    <TableCell>{key}</TableCell>
                    <TableCell>{value}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {error && (
          <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
            <Alert severity="error">خطا در پاسخ</Alert>
            <pre
              style={{
                backgroundColor: "#fff0f0",
                padding: "10px",
                borderRadius: "5px",
                maxHeight: "300px",
                overflow: "auto",
                direction: "ltr",
              }}
            >
              {JSON.stringify(error, null, 2)}
            </pre>
          </Paper>
        )}
      </Box>
    </Paper>
  );
};

export default Wallet;